<template>
  <modal :name="modalName" transition="fade" top="0" width="700" height="auto" draggable="true"
    @before-open="beforeOpen" :adaptive="true">
    <div class="modal-container">
      <div class="modal-header">
        <h3>Create User</h3>
        <button @click=close>X</button>
      </div>
      <div class="modal-content">
        <div class="modal-intro-information">
          <label>User First Name</label>
          <input ref="title" type="text" placeholder="First Name" class="modal-user-title" v-model="firstName" />
          <label>User Last Name</label>
          <input ref="title" type="text" placeholder="Last Name" class="modal-user-title" v-model="lastName" />
          <!-- <div class="upload-attachment">
            <button @click="() => handleUploadAttachments()">
              <img src="../../assets/Icons/CTicons-02.png" width="23" height="23">
              <b>Upload Image</b>
            </button>
          </div> -->
        </div>
        <div class="modal-create-data">
          <div class="modal-create-data-item">
            <p>User Role*</p>
            <div @mouseleave="showRoles = false" style="flex:1; z-index: 2; display: flex;" ref="residentData">
              <option-dropdown-select v-if="showRoles" class="search" style="top: 36px" :options="allowedRoles"
                :onOptionSelected="(option, event) => {
                  event.stopImmediatePropagation()
                  role = option.value;
                  showRoles = false
                }" />
              <button v-else class="option-select-dropdown-button"
                style="flex: 1; display: flex; align-items: center; justify-content: center;">
                <div
                  style="display: flex; width: 100%; height: 100%; flex-direction: row; justify-content: flex-end; align-items: center;"
                  @mousedown="showRoles = !showRoles">
                  <p style="text-align: center; margin-left: 8px; border-right: none !important;"
                    @mousedown="showRoles = !showRoles">
                    {{ roleDisplay }}</p>
                  <div style="padding-right: 8px; font-weight: bolder; flex: none !important; border: none !important;">
                    <svg width="10" height="6" viewBox="0 0 10 6" fill="none">
                      <path d="M1 1L5 5L9 1" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                        stroke-linejoin="round" />
                    </svg>
                  </div>
                </div>
              </button>
            </div>
          </div>
          <div class="modal-create-data-item">
            <p>Unit*</p>
            <div @mouseleave="showUnitsOptions = false" style="flex:1; z-index: 1; display: flex;" ref="unitData">
              <option-dropdown-select v-if="showUnitsOptions" class="search" style="top: 36px" :options="units"
                :searchCallback="(data) => fetchUnits(data)" :onOptionSelected="(option, event) => {
                  event.stopImmediatePropagation()
                  handleUnitSelected(option)

                }" />
              <button v-else-if="unitData != null" class="option-select-dropdown-button"
                style="flex: 1; display: flex; align-items: center; justify-content: center;">
                <p style="text-align: center;" @click="showUnitsOptions = !showUnitsOptions">
                  {{ unitData.name }}</p>
              </button>
              <button v-else class="option-select-dropdown-button"
                style="flex: 1; display: flex; align-items: center; justify-content: center;">
                <div
                  style="display: flex; width: 100%; height: 100%; flex-direction: row; justify-content: flex-end; align-items: center;"
                  @click="showUnitsOptions = !showUnitsOptions">
                  <div style="padding-left: 8px; padding-right: 8px; font-weight: bolder; flex: none !important;">
                    <svg width="10" height="6" viewBox="0 0 10 6" fill="none">
                      <path d="M1 1L5 5L9 1" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                        stroke-linejoin="round" />
                    </svg>
                  </div>
                </div>
              </button>
            </div>
          </div>
          <div class="modal-create-data-item">
            <p>Email*</p>
            <input ref="email" type="text" placeholder="Email Name" class="modal-user-title" v-model="email" />
          </div>
          <div class="modal-create-data-item">
            <p>Phone Number</p>
            <input ref="phone" type="text" placeholder="Phone Number" class="modal-user-title" v-model="phone" />
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button @click="createUser()">Create User</button>
        <div class="toggle-container">
          <SlideToggle v-model="sendInvitation" />
          <p>Send Invitation?</p>
        </div>
      </div>
    </div>
  </modal>
</template>

<script>
import * as Constants from "../../js/constants.js";
import CTSRepository from "../../js/CTSRepository.js";
import OptionDropdownSelect from "../layout/OptionDropdownSelect.vue";
import * as Utils from "../../js/Utils.js"
import SlideToggle from "../pages/pageComps/SlideToggle.vue";
import { roleAccessOrder } from "../../js/features.js";

const NAME = Constants.CREATE_USERS_MODAL

export default {
  modalName: NAME,
  props: ["organizationData", "userData"],

  components: {
    OptionDropdownSelect,
    SlideToggle
  },
  opened(event) {
    console.log('Opening...', event)
  },
  watch: {
    title(newValue) {
      if (newValue != "") this.$refs['title'].classList.remove('invalid')
    },
    description(newValue) {
      if (newValue != "") this.$refs['description'].classList.remove('invalid')
    },
    email(newVal) {
      if (Utils.isValidEmail(newVal)) {
        this.$refs['email'].classList.remove('invalid')
      } else {
        this.$refs['email'].classList.add('invalid')
      }
    },
    phone(newVal) {
      if (Utils.isValidPhoneNumber(newVal)) {
        this.$refs['phone'].classList.remove('invalid')
      } else {
        this.$refs['phone'].classList.add('invalid')
      }
    }
  },
  data() {
    return {
      modalName: NAME,
      firstName: "",
      lastName: "",
      email: "",
      phone: "",
      sendNotifications: false,
      showRoles: false,
      role: "",
      roles: [
        { name: "Admin", value: "admin" },
        { name: "HOA Admin", value: "hoa_admin" },
        { name: "Guard", value: "guard" },
        { name: "Resident", value: "resident" },
        { name: "Secondary User", value: "secondary_user" },
      ],
      units: [],
      unitData: null,
      showUnitsOptions: false,
      sendInvitation: true,
    }
  },
  methods: {
    show() {
      this.$modal.show(NAME);
    },
    beforeOpen(event) {
      console.log('Before Opening...', event)
      this.fetchUnits()
    },
    validateKey() {
      console.log("Validating key...")
    },
    close() {
      this.$modal.hide(NAME);
    },
    getReporterText() {
      return `${this.currentUser.first_name} ${this.currentUser.last_name}`
    },
    setLocation(location) {
      this.selectedLocation = location;
      this.showLocations = false;
      this.$refs['location'].classList.remove('invalid')
    },
    setType(type) {
      this.selectedType = type;
      this.showTypes = false;
      this.$refs['type'].classList.remove('invalid')
    },
    setPriority(priority) {
      this.selectedPriority = priority;
      this.showPriorities = false;
      this.$refs['priority'].classList.remove('invalid')
    },
    setStatus(status) {
      this.selectedStatus = status;
      this.showStatuses = false;
      this.$refs['status'].classList.remove('invalid')
    },
    setSelectedResident(resident) {
      this.selectedResident = resident;
      this.showResidents = false;
      this.$refs['resident'].classList.remove('invalid')
    },
    setAssignee(user) {
      this.selectedAssignee = user;
      this.showAssignees = false;
      this.$refs['assignee'].classList.remove('invalid')
    },
    getSelectedResidentText() {
      if (this.selectedResident === null) return ""
      else return `${this.selectedResident.first_name} ${this.selectedResident.last_name} (${this.selectedResident.subdivision})`
    },
    getSelectedAssigneeText() {
      if (this.selectedAssignee === null) return ""
      else return `${this.selectedAssignee.first_name} ${this.selectedAssignee.last_name}`
    },
    inputsValid() {
      let warnings = []

      if (!Utils.isValidEmail(this.email)) {
        warnings.push("Email is incorrectly formatted, please format as email@provider.com")
      }
      // Phone
      if (!Utils.isValidPhoneNumber(this.phone)) {
        warnings.push("Phone Number is incorrectly formatted, please format as +19991234567")
      }
      if (warnings.length > 0) {
        alert(warnings.join('\n'))
        return false
      } else {
        return true
      }
    },
    async fetchUnits() {
      if (this.$props.organizationData == null) return
      new CTSRepository({
        organization_id: this.organizationData.organization_id
      }).searchUnits("", { unit_full_address: "" }).then(async (responseData) => {
        console.log("Units Search Data", responseData);
        let mappedData = responseData.sort((a, b) => a.unit_address.toLowerCase().localeCompare(b.unit_address.toLowerCase())).map(unit => {
          return {
            key: `${unit.unit_full_address}`,
            name: `${unit.unit_address} ${unit.unit_address_2}`,
            value:  {
              address: unit.unit_full_address,
              unit_id: unit.unit_id
            }
          };

        })

        console.log("Mapped Data", mappedData);

        this.units = mappedData
      }).catch(() => {

      });

    },
    handleUnitSelected(option) {
      console.log('Units option clicked', option)
      this.unitData = option;
      this.showUnitsOptions = false
    },
    createUser() {
      if (!this.inputsValid()) {
        return;
      }
      // Support multiple unit associations in the future
      const unitsForAssociation = []
      unitsForAssociation.push(this.unitData.value.unit_id)
      const createUserInput = {
        "first_name": this.firstName,
        "last_name": this.lastName,
        "address": this.unitData.value.address,
        "primary_email_address": this.email,
        "primary_phone_number": this.phone,
        "secondary_email_address": "",
        "secondary_phone_number": "",
        "lifesaving_equipment": "",
        "mobility_assistance": "",
        "subdivision": "",
        "role": this.role,
        "reporter": this.$props.userData.sub,
        "send_invitation": this.sendInvitation,
        "units": unitsForAssociation
      }

      console.log("Create User Input", createUserInput)

      new CTSRepository(this.$props.organizationData).createUser(JSON.stringify(createUserInput))
        .then((data) => {
          console.log("Create User Data", data);
          this.close()
        })
        .catch((err) => {
          console.log("Error Creating User Data", err);
        });
    },
    handleUploadAttachments() {
      alert("Upload Attachments")
    }
  },
  computed: {
    roleDisplay() {
      return this.$roleNameMap[this.role]
    },
    allowedRoles() {
      const currentUserRole = this.userData["custom:cts_role"]
      const indexOfCurrentRole = roleAccessOrder.indexOf(currentUserRole)
      const rolesBelowCurrentAccess = this.roles.filter(item => {
        return roleAccessOrder.indexOf(item.value) <= indexOfCurrentRole
      })
      return rolesBelowCurrentAccess
    }
  },
  created() {
    console.log("In modal")
    console.log("Create User Modal Params", this.$$props)
  },
}
</script>

<style scoped>
.modal-container {
  display: flex;
  flex-direction: column;
  background-color: #699991;
  color: white;
  border-radius: 4px;
}

.modal-create-data-item input {
  flex: 1;
  height: 100%;
  width: 100%;
  font-size: 14px;
  outline: 0;
  border: 0;
  text-align: center;
}

.visitor-modal-title::placeholder {
  color: black;
}

.validate-button {
  color: white;
  background-color: #87BAB7;
  width: 60%;
  margin-left: auto;
  margin-right: auto;
  height: 2rem;
  border-radius: 5px;
  margin-top: .5rem;
  margin-bottom: .5rem;
}

.modal-field {
  padding: 1rem;
  font-size: 25px;
  border-bottom: 1px solid #87BAB7;
}

.modal-time-info {
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
}

.modal-time-inner {
  display: flex;
  flex-direction: column;
  padding: 1rem;
  border-right: 1px solid #87BAB7;
  border-left: 1px solid #87BAB7;
}

.helper-text {
  text-align: left;
  font-size: 15px;
}

.circle {
  width: 160px;
  height: 160px;
  line-height: 160px;
  border-radius: 50%;
  font-size: 50px;
  color: #fff;
  text-align: center;
  background: #87BAB7;
}

.resident-search-bar {
  display: flex;
  width: 100%;
  height: 100%;
  font-size: 12px !important;
  background-color: #F3F3F3;
  align-items: center;
  border-radius: 0px;
  border: 0;
}

.resident-search-bar::placeholder {
  color: black;
}

.resident-search-bar input {
  background-color: white;
  text-align: center;
}

.modal-header {
  padding: 1rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: white;
  border-radius: 4px;
  color: black;
  border: 1px solid black;
}

.modal-header h3 {
  font-size: 36px;
}

.modal-content {
  padding: 2rem;
}

.modal-intro-information {
  display: flex;
  flex-direction: column;
}

.modal-intro-information label {
  color: black;
  text-align: left;
  text-decoration: underline;
}

.modal-user-title {
  font-size: 24px;
  margin-bottom: 18px;
  border-bottom: 1px solid black;
  text-decoration: none;
  outline: 0;
}

.modal-user-title::placeholder {
  color: #d9d9d988;
}

.modal-user-description {
  font-size: 14px;
  font-weight: lighter;
  border-bottom: 1px solid black;
  text-decoration: none;
  outline: 0;
  margin-bottom: 18px;
  resize: none;

}

.modal-user-description::placeholder {
  color: #d9d9d988;
}

.upload-attachment {}

.upload-attachment button {
  display: flex;
  flex-direction: row;
  padding: 8px;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  background-color: #d9d9d9dd;
  color: black
}

.modal-dropdown-button {
  color: black;
  background-color: #d9d9d9;
  padding: 4px 8px;
  margin-right: 10px;
  border: 1px solid black;
  border-radius: 4px;
}

.modal-create-data {
  margin-top: 41px;
  display: flex;
  flex-direction: column;
}

.modal-create-data-item {
  display: flex;
  flex-direction: row;
  color: black;
  border: 1px solid black;
  height: 36px;
  border-radius: 4px;
}

.modal-create-data-item input {
  flex: 1;
  background-color: #d9d9d9;
  text-align: center;
}

.modal-create-data-item p {
  align-content: center;
  text-align: left;
  font-weight: bold;
  flex: 1;
  padding-left: 8px;
  border-right: 1px solid black;
}

.modal-create-data-item textarea {
  align-content: center;
  text-align: left;
  font-weight: bold;
  flex: 1;
  height: 100%;
  resize: none;
  font-size: 14px;
  font-weight: lighter;
  outline: 0px;
  background-color: #d9d9d9dd;
}

.modal-create-data-item div {
  flex: 1;
  background-color: #d9d9d9;
}

.modal-create-data-item button {
  flex: 1;
  width: 100%;
  height: 100%;
  background-color: #ccd9d9d9;
}

.modal-create-data-item div ul {
  height: 100%;
}

.modal-create-data-item div li {
  position: relative;
  flex: 1;
  list-style: none;
  text-decoration: none;
  background-color: white;
  text-align: center;
  height: 100%;
  align-items: center;
  justify-content: center;
  z-index: 2;
  border-bottom: 1px solid #ccd9d9d9;

}

.modal-create-data-item div li:hover {
  background-color: #699991;
}

.invalid {
  outline: 1px solid red;
}

.modal-footer {
  padding: 1rem;
  display: flex;
  flex-direction: row-reverse;
  align-items: center;
  justify-content: space-between;
  background-color: white;
  border-radius: 4px;
  color: black;
  border: 1px solid black;
}

.toggle-container {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.toggle-container p {
  margin-left: 8px;
}

.modal-footer button {
  background-color: #699991;
  padding: 4px 24px;
  border-radius: 4px;
  border: 1px solid black;
  font-weight: bold;

}
</style>